import FormBuilderConfig from "../../../../toolkit/baseForms2/formBuilder/FormBuilder.config";
import ICheckBuilder from "../../../../toolkit/baseForms2/iCheckBuilder/ICheckBuilder";

export const MOSTRAR_CONTACT_CENTER = "mostrarContactCenter";

const MESES = [
  "Ene",
  "Feb",
  "Mar",
  "Abr",
  "May",
  "Jun",
  "Jul",
  "Ago",
  "Sep",
  "Oct",
  "Nov",
  "Dic"
];

const formatPeriodo = (isoDate: string): string => {
  const [_, mes] = isoDate.split("-");
  const idx = parseInt(mes, 10) - 1;

  // Solo para asegurar, que el formato  es el esperado
  if (idx < 0 || idx > 11) {
    return isoDate;
  }

  return `${MESES[idx]}`;
};

// Builder de FormConfig para los filtros dinámicos de periodos
export const opcionesFormConfigBuilder = (
  periodosMensuales: string[]
): FormBuilderConfig<string, string> => {
  // Checkboxes de cada periodo
  const periodoInputs = periodosMensuales.map(periodo => ({
    name: periodo,
    label: formatPeriodo(periodo),
    bts: { mCol: 1 },
    component: ICheckBuilder,
    props: { addTopMargin: false }
  }));

  // Filtro para ocultar columnas informativas de Contact Center, al principio
  return {
    inputs: [
      {
        name: MOSTRAR_CONTACT_CENTER,
        label: "Mostrar Club vs C.C.",
        bts: { mCol: 2 },
        component: ICheckBuilder,
        props: { addTopMargin: false }
      },
      ...periodoInputs
    ],
    buttons: [],
    rows: [[MOSTRAR_CONTACT_CENTER, ...periodosMensuales]]
  };
};

// Inicialización de los checkboxes, todos activos
export const opcionesInitializer = (
  periodosMensuales: string[]
): { [key: string]: boolean } => {
  const init = {
    [MOSTRAR_CONTACT_CENTER]: true
  };

  periodosMensuales.forEach(periodo => {
    init[periodo] = true;
  });

  return init;
};
